import { translator } from 'core/localization/localization';

export const i18n = translator({
	'Pivot to Data Rows: Displays values from datasource rows instead of displaying them by columns.': {
		en: 'Pivot to Data Rows: Displays values from datasource rows instead of displaying them by columns.',
		no: 'Roter til Data Rader: Viser verdier fra datakilderader i stedet for å vise dem per kolonne.',
	},
	'Datasource chart': {
		en: 'Datasource chart',
		no: 'Datakilde diagram',
	},
	'Pie': {
		en: 'Pie',
		no: 'Pie',
	},
	'3D Pie': {
		en: '3D Pie',
		no: '3D Pie',
	},
	'Vertical': {
		en: 'Vertical',
		no: 'Vertikal',
	},
	'Horizontal': {
		en: 'Horizontal',
		no: 'Horisontal',
	},
	'Chart': {
		en: 'Chart',
		no: 'Diagram',
	},
	'Chart type': {
		en: 'Chart type',
		no: 'Diagramtype',
	},
	'Bar chart': {
		en: 'Bar chart',
		no: 'Søylediagram',
	},
	'Pie chart': {
		en: 'Pie chart',
		no: 'Sektordiagram',
	},
	'Vertical stacked': {
		en: 'Vertical stacked',
		no: 'Vertikalt stablet',
	},
	'Horizontal stacked': {
		en: 'Horizontal stacked',
		no: 'Horisontalt stablet',
	},
	'Donut': {
		en: 'Donut',
		no: 'Smultring',
	},
	'Display': {
		en: 'Display',
		no: 'Visning',
	},
	'Data not found': {
		en: 'Data not found',
		no: 'Data ikke funnet',
	},
	'Pivot data': {
		en: 'Pivot data',
		no: 'Pivoter data',
	},
	'Pivot data lets you turn the datasource table into a summary (pivot) grid.': {
		en: 'Pivot data lets you turn the datasource table into a summary (pivoted) grid.',
		no: 'Pivoter data lar deg gjøre datakilde tabellen om til et sammendrag (pivot-tabell).',
	},
	'Color': {
		en: 'color',
		no: 'Farge',
	},
	'Column': {
		en: 'Column',
		no: 'Kolonne',
	},
	'Column: Unique values in this field become headers and are used to aggregate values.': {
		en: 'Column: Unique values in this field become headers and are used to aggregate values.',
		no: 'Kolonne: Unike verdier i dette feltet blir kolonneoverskrifter og brukes til å aggregere verdier.',
	},
	'Value': {
		en: 'Value',
		no: 'Verdi',
	},
	'Values: The numeric field(s) to summarize.': {
		en: 'Values: The numeric field(s) to summarize.',
		no: 'De numeriske feltene som skal oppsummeres.',
	},
	'Color range': {
		en: 'Color range',
		no: 'Fargespekteret',
	},
	'Custom colors': {
		en: 'Custom colors',
		no: 'Tilpasset farger',
	},
	'Row label': {
		en: 'Row label',
		no: 'Rad navn',
	},
	'Row label (index): Selected column(s) define the categories that appear on your chart.': {
		en: 'Row label (index): Selected column(s) define the categories that appear in your chart.',
		no: 'Radetikett (indeks): Valgte kolonner definerer kategoriene som vises i diagrammet.',
	},
	'Hide Legend': {
		en: 'Hide legend',
		no: 'Skjul tegnforklaring',
	},
	'Number': {
		en: 'Number',
		no: 'Tall',
	},
	'Text': {
		en: 'Text',
		no: 'Tekst',
	},
	'Invert': {
		en: 'Invert',
		no: 'Inverter',
	},
	'Row labels are required': {
		en: 'Row labels are required',
		no: 'Rad navn er påkrevd',
	},
	'Show datasource grid on click': {
		en: 'Show datasource grid on click',
		no: 'Vis datasource kilde på klikk',
	},
	'Drilldown Datasource': {
		en: 'Drilldown datasource',
		no: 'Drilldown datakilde',
	},
	'Use Chart Datasource (set above)': {
		en: 'Use chart datasource (set above)',
		no: 'Bruk diagram datakilde (valgt over)',
	},
	'Split values': {
		en: 'Split values',
		no: 'Splitt verdier',
	},
	'Split values to separate chart columns': {
		en: 'Split values to separate chart columns',
		no: 'Split verdier til egne diagram stolper',
	},
	'Export to CSV': {
		en: 'Export to CSV',
		no: 'Eksporter til CSV',
	},
	'Decimal Numbers': {
		en: 'Decimal numbers',
		no: 'Desimaltall',
	},
	'Time': {
		en: 'Time',
		no: 'Tid',
	},
	'When disabled, the default time period from the datasource will be applied': {
		en: 'When inactive, the default time period from the datasource will be applied',
		no: 'Når denne er deaktivert, brukes standard tidsperiode fra datakilden',
	},
	'The Title is required': {
		no: 'Tittel er obligatorisk',
	},
	'The Datasource field is required': {
		no: 'Datakildefeltet er obligatorisk',
	},
	'The Account is required': {
		no: 'Kontoen er obligatorisk',
	},
	'The default for {0} is {1}': {
		en: 'The default for {0} is {1}',
		no: 'Standard for {0} er {1}',
	},
	'Time column': {
		en: 'Time column',
		no: 'Tidskolonne',
	},
	'This datasource does not have a time column and cannot use the time selector': {
		en: 'This datasource does not have a time column and cannot use the time selector',
		no: 'Denne datakilden har ikke tidskolonne og kan ikke bruke tidsvelger',
	},
});
